<template>
  <div class="head-info" :class="center && 'center'">
    <span>{{ title }}</span>
    <p><a>{{ content }}</a></p>
  </div>
</template>

<script>
export default {
  name: 'HeadInfo',
  props: {
    title: {
      default: ''
    },
    content: {
      default: ''
    },
    bordered: {
      default: false
    },
    center: {
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
  .head-info {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;

    &.center {
      text-align: center;
      padding: 0 5px;
    }

    span {
      color: rgba(0, 0, 0, .45);
      display: inline-block;
      font-size: .8rem;
      line-height: 32px;
      margin-top: 4px;
    }
    p {
      line-height: 32px;
      margin: 0;
      a {
        font-weight: 400;
        font-size: 1.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/HeadInfo.vue